module.exports = __webpack_public_path__ + "img/Zwaardboten.88e94821.svg";